function EnrolleeCardView() {
    "use strict";

    this.Enrollee = null;

    this.Id = -1;
    this.IsAssigned = false;
    this.LastLatitude = 0.0;
    this.LastLongitude = 0.0;
    this.LastContactDate = new Date(0);
    this.LastContactDateDisplay = '- unassigned -';
    this.LastTrackpointDate = new Date(0);
    this.LastTrackpointDateDisplay = '- unassigned -';
    this.LastContactBatteryLevel = '';
    this.LastContactBatteryDisplay = 'none';
    this.LastContactVersion = '';
    this.FullName = '';
    this.FirstName = '';
    this.LastName = '';
    this.PrimaryId = '';
    this.EnrolleeType = 1;

    this.TrackingDeviceId = -1;
    this.TrackingDeviceDisplay = 'none';
    this.TrackingDeviceSerialNumber = '- unassigned -';
    this.TrackingDeviceContactDate = new Date(0);
    this.TrackingDeviceContactDateDisplay = '';
    this.LastCheckDateDisplay = '';
    this.LastCheckDisplay = 'none';
    this.LastTestDateDisplay = '';
    this.LastTestDisplay = 'none';
    this.TrackingDeviceContactDisplay = 'none';
    this.StationDeviceId = -1;
    this.StationDeviceDisplay = 'none';
    this.StationDeviceSerialNumber = '- unassigned -';
    this.StationDeviceContactDate = new Date(0);
    this.StationDeviceContactDateDisplay = '';
    this.StationDeviceContactDisplay = 'none';

    this.DeviceSerialNumber = '- unassigned -';
    this.DeviceId = -1;
    this.DeviceTrackType = -1;
    this.LastContactDisplay = 'none';
    this.HasGpsDevice = false;
    this.DeviceStatus = '';
    this.DeviceStatusId = '';
    this.DeviceStatusDisplay = 'none';

    this.RiskLevelId = '';
    this.HasOpenEvents = false;
    //this.BadClosedNotConfirmed = 0;
    //this.BadClosedConfirmed = 0;
    //this.BadOpenNotConfirmed = 0;
    //this.BadOpenConfirmed = 0;
    //this.GoodClosedNotConfirmed = 0;
    //this.GoodClosedConfirmed = 0;
    //this.GoodOpenNotConfirmed = 0;
    //this.GoodOpenConfirmed = 0;

    this.TamperEventDisplay = 'none';
    this.ZoneEventDisplay = 'none';
    this.ScheduleEventDisplay = 'none';
    this.EventIconDisplay = 'none';

    this.VictimEventLevel = '';
    this.VictimIconDisplay = 'none';
    this.VictimEventLevelDesc = '';

    this.LastContactBatteryImage = '';

    // included for filter/search operations
    this.SecondaryId = '';
    this.AgentName = '';
    this.OrganizationId = '';
    this.IsMyCaseload = false;
    this.InMyOrganization = false;

    //Enrollee Paired victim
    this.HasVictimDisplay = 'none';

    //Enrollee has association
    this.AssociationEventDisplay = 'none';
    this.HasAssociationFlag = false;
    this.LastAssociationDate = "";    
    this.EnrolleesMapTransactionStartDate = null;
    this.EnrolleesMapTransactionStopDate = null;

    //ema
    this.HasEmaEvents = 'none';

    //sobertrack
    this.HasSoberTrackDevice = false;
    this.SoberTrackDisplay = 'none';
    this.SobertrackUsage = 'None';
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeCardView;
}